import { Button, notification } from 'antd'
import React, { useState } from 'react'
import { t } from '../../../../../system/i18n'
import apiService from '../../apiService'
import { convertBlobDataToExcel } from '../../../../../system/support/helpers'

const DownloadDeliveryNoteReturn = ({ filter }) => {
    const [loading, setLoading] = useState(false)

    const handleDownload = () => {
        setLoading(true)
        apiService
            .exportExcel(filter)
            .then(response => {
                // Kiểm tra nếu response là blob (file Excel)
                if (response.data instanceof Blob && response.data.type !== 'application/json') {
                    notification.success({
                        message: t('delivery_note:message.download_success')
                    });
                    convertBlobDataToExcel(response.data, 'DANH SÁCH PHIẾU TRẢ HÀNG')
                } else {
                    // Nếu response là JSON (lỗi từ server)
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const errorData = JSON.parse(reader.result);
                            const message = (errorData && errorData.message) || (errorData && errorData.data && errorData.data.message) || '';
                            if (message === 'over_limit') {
                                notification.error({
                                    message: t('delivery_note:message.export_over_limit', { limit: 2000 })
                                });
                            } else if (message === 'empty') {
                                notification.warning({
                                    message: t('delivery_note:message.export_empty')
                                });
                            } else {
                                notification.error({
                                    message: t('delivery_note:message.download_failed')
                                });
                            }
                        } catch (e) {
                            notification.error({
                                message: t('delivery_note:message.download_failed')
                            });
                        }
                    };
                    reader.readAsText(response.data);
                }
            })
            .catch(() => {
                notification.error({
                    message: t('delivery_note:message.download_failed')
                });
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <Button
            type="primary"
            loading={loading}
            onClick={handleDownload}
            className="a-btn a-btn--primary a-btn--h-25 a-btn--font-small a-text--regular __download-list mr-2">
            {t('delivery_note:btn.download_list')}
        </Button>
    )
}

export default DownloadDeliveryNoteReturn
